import {ILoggedInUser} from "../auth/Helper";
import {IUserTicket} from "../ticket/Helper";

export interface IClientState {
    items: IClient[]
    selectedClient: IClient
    fetchClientLoading: boolean
    fetchClientsLoading: boolean
    clientActionLoading: boolean
    clientWishTicketsLoading: boolean
    clientWishTickets: IClientWishTicketsResponse
    disableClientUserLoading: boolean
}

export interface IClient {
    id: string
    name: string
    is_active: boolean
    company_logo: string
    contact: string | null
    created_at: string
    is_contractor: boolean
    users: ILoggedInUser[]
}

export interface IClientWishTicketsResponse {
    total_pages: number
    count: number
    data: IUserTicket[]
}

export const initialClient: IClient = {
    id: '',
    name: '',
    is_active: true,
    company_logo: '',
    contact: null,
    created_at: '',
    is_contractor: false,
    users: [],
}